import React, { useState, useEffect } from 'react';
import './index.css';
import {
  Container,
  Col,
  Row,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  editCompetitionInsights,
  addCompetition,
  editDealer,
} from '../../../constants/apiCalls';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import ModalService from '../../../services/ModalService';
import { DashBoardTitle } from '../../../Components/Title';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { CommonButton, CommonCompetition } from '../../../Components/CommonComponents';
import FYearService from '../../../services/FYearService';
import { CompanyModal, SegmentModal } from '../../../Components/CustomModal';
import { handleErrorMessage } from '../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const BusinessCompetitionInsights = () => {
  let fYYear = FYearService.getFYear();
  let location = useLocation();
  const navigate = useNavigate();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [isKycRequired, setIsKycRequired] = useState(false);
  const [title, setTitle] = useState({});

  // Competition segment
  const [segmentData, setSegmentData] = useState('');
  const [editSegmentId, setEditSegmentId] = useState('');
  const [segmentName, setSegmentName] = useState('');
  const [segmentYear, setSegmentYear] = useState('');
  const [segmentTurnOver, setSegmentTurnOver] = useState('');
  const [totalSegmentTurnOver, setTotalSegmentTurnOver] = useState('');
  const [segmentModal, setSegmentModal] = useState(false);

  // Competition company
  const [companyData, setCompanyData] = useState('');
  const [editCompanyId, setEditCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyYear, setCompanyYear] = useState('');
  const [companyTurnOver, setCompanyTurnOver] = useState('');
  const [totalCompanyTurnOver, setTotalCompanyTurnOver] = useState('');
  const [companyModal, setCompanyModal] = useState(false);

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (userId) {
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, []);

  useEffect(() => {
    const segment = dealerObj.segment_wise_business_competition || [];
    const company = dealerObj.company_wise_business_competition || [];
    let totalSegmntTurnOver = segment && segment.length > 0 ? segment.map((val) => val.turnover) : [];
    let totalCompnyTurnOver = company && company.length > 0 ? company.map((val) => val.turnover) : [];
    setIsKycRequired(dealerObj.is_approved);
    setTotalCompanyTurnOver(totalCompnyTurnOver);
    setTotalSegmentTurnOver(totalSegmntTurnOver);
    setCompanyData(company);
    setSegmentData(segment);
    setTitle({ name: dealerObj.business_name, page: dealerObj.page_6 });
  }, [dealerObj])

  const handleAddSegment = (e, key) => {
    setSegmentTurnOver();
    setSegmentName();
    setSegmentYear();
    setEditSegmentId('');
    setSegmentModal(!segmentModal);
  };

  const handleEditSegment = (val, key) => {
    setSegmentYear(val.year);
    setSegmentName(val.segment);
    setSegmentTurnOver(val.turnover);
    setEditSegmentId(val.id);
    setSegmentModal(!segmentModal);
  };

  const handleSegmentSubmit = (e) => {
    e.preventDefault();
    let payload = {
      user_id: parseInt(userId),
      segment: segmentName,
      year: fYYear.prevFinancialYear,
      turnover: parseInt(segmentTurnOver.toString().replace(/\D/g, '')),
      type: '',
    };
    if (payload.user_id && !editSegmentId) {
      setIsloading(false);
      setIsModalLoading(true);
      addCompetition((res) => {
        const { message, success, error } = res;
        if (success === true) {
          if (companyData.length > 3 && segmentData.length > 4) {
            let dealerPayload = {
              id: parseInt(userId),
              page_6: 1,
            };
            editDealer((res) => { }, dealerPayload);
          }
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setSegmentModal(!segmentModal);
          setSegmentTurnOver();
          setSegmentName();
          setSegmentYear();
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }
    if (editSegmentId) {
      let editPayload = {
        id: editSegmentId,
        segment: segmentName,
        year: segmentYear,
        turnover: parseInt(segmentTurnOver.toString().replace(/\D/g, '')),
        type: '',
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCompetitionInsights((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setSegmentModal(!segmentModal);
          setSegmentTurnOver();
          setSegmentName();
          setSegmentYear();
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }
  };

  const handleAddCompany = (e, key) => {
    setCompanyModal(!companyModal);
    setCompanyTurnOver();
    setCompanyName();
    setCompanyYear();
    setEditCompanyId('')
  };

  const handleEditCompany = (val, key) => {
    setCompanyName(val.company_name);
    setCompanyTurnOver(val.turnover);
    setCompanyYear(val.year);
    setEditCompanyId(val.id);
    setCompanyModal(!companyModal);
  };

  const handleSubmitCompany = (e) => {
    e.preventDefault();
    let payload = {
      user_id: parseInt(userId),
      company_name: companyName,
      year: fYYear.prevFinancialYear,
      turnover: companyTurnOver ? parseInt(companyTurnOver.toString().replace(/[^0-9]/g, '')) : null,
      type: '',
    };
    if (payload.user_id && !editCompanyId) {
      setIsloading(false);
      setIsModalLoading(true);
      addCompetition((res) => {
        const { message, success, error } = res;
        if (success === true) {
          if (companyData.length > 3 && segmentData.length > 4) {
            let dealerPayload = {
              id: parseInt(userId),
              page_6: 1,
            };
            editDealer((res) => { }, dealerPayload);
          }
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setCompanyModal(!companyModal);
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
    }
    if (editCompanyId) {
      let editPayload = {
        id: editCompanyId,
        company_name: companyName,
        year: companyYear,
        turnover: companyTurnOver ? parseInt(companyTurnOver.toString().replace(/\D/g, '')) : null,
        type: '',
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCompetitionInsights((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
          setIsloading(false);
          setCompanyModal(!companyModal);
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editPayload);
    }
  };

  const handleSaveAsDraft = () => {
    if ((companyData.length >= 0 && segmentData.length >= 0)) {
      let dealerPayload = {
        id: parseInt(userId),
        page_6: 0,
      };
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, dealerPayload);
    }
  };

  const finalSubmit = () => {
    if (companyData.length > 2 && segmentData.length > 4) {
      let dealerPayload = {
        id: parseInt(userId),
        page_6: 1,
      };
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, dealerPayload);
    }
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='BusinessCompetitionInsights'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Competition Insights' />
                    </Col>
                  </Row>
                  <div className='businessCompetBlock'>
                    <div className='businessCompetBlockInner'>
                      <Row>
                        <Col xs={12}>
                          <div className='dealerRegBlocktitle text-center text-capitalize noprint'>Competition Insights</div>
                        </Col>
                        <Col xs={12}>
                          <p className='commonNote text-center'>
                            (Please note:details of all 5 Inputs are mandatory. Turnover
                            of last financial year, for a minimum of three companies is mandatory. Collect the details of all top companies)
                          </p>
                        </Col>
                      </Row>
                      <CommonCompetition
                        handleAddSegment={handleAddSegment}
                        handleAddCompany={handleAddCompany}
                        handleEditSegment={handleEditSegment}
                        handleEditCompany={handleEditCompany}
                        totalSegmentTurnOver={totalSegmentTurnOver}
                        totalCompanyTurnOver={totalCompanyTurnOver}
                        segmentData={segmentData}
                        companyData={companyData}
                      />
                      <Row>
                        <Col xs={12}>
                          <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                            {isKycRequired ? (
                              <CommonButton name={'Cancel'} btnClass={'btnSecondary'} type="button" onClick={handleBack} />
                            ) : (

                              <CommonButton name={'Save as Draft'} btnClass={'btnSecondary'} type="button" onClick={handleSaveAsDraft} />
                            )}
                            <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="button" onClick={finalSubmit} disabled={segmentData.length < 5 || companyData.length < 3} />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Container>
              </div>

              {/* Input wise Segment - competition insights modals */}
              <SegmentModal
                isModalLoading={isModalLoading}
                isOpen={segmentModal}
                toggle={() => setSegmentModal(!segmentModal)}
                editSegmentId={editSegmentId}
                handleSegmentSubmit={handleSegmentSubmit}
                segmentName={segmentName}
                setSegmentName={setSegmentName}
                segmentYear={segmentYear}
                segmentTurnOver={segmentTurnOver}
                setSegmentTurnOver={setSegmentTurnOver}
              />

              {/* Company wise - competition insights modals */}
              <CompanyModal
                isModalLoading={isModalLoading}
                isOpen={companyModal}
                toggle={() => setCompanyModal(!companyModal)}
                editCompanyId={editCompanyId}
                handleSubmitCompany={handleSubmitCompany}
                companyName={companyName}
                setCompanyName={setCompanyName}
                companyYear={companyYear}
                companyTurnOver={companyTurnOver}
                setCompanyTurnOver={setCompanyTurnOver}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessCompetitionInsights;
